import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import FileFormContainer from '../../containers/files/FileFormContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const NewFile = ({ slug, projectId, initiativeType, initiativeId }) => (
  <>
    <Helmet>
      <title>Add Linked File | ChangeSync</title>
    </Helmet>
    <FileFormContainer
      title="Add Linked File"
      slug={slug}
      projectId={projectId}
      initiativeType={initiativeType}
      initiativeId={initiativeId}
    />
  </>
);

NewFile.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
});

NewFile.propTypes = {
  projectId: PropTypes.number.isRequired,
  initiativeId: PropTypes.number,
  initiativeType: PropTypes.string,
};

export default requireAuth(withRouterParams(NewFile));
